<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <Modal v-if="showModalListDocuments" :widthContainer="'90% !important'" :heightContainer="'50% !important'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#174a84;">{{modalTitle}}</h3>
      <div slot="body">
        <div class="">
          <div class="grid grid-cols-2 gap-4" style="border: 1px solid #12B3BD;padding:10px;margin-top:10px;"
           v-for="(document, index) in documents_list_filtered" :key="index">
            <div style="">
              <p style="width:70%;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Documento:</p>
              <p style="width:70%;word-wrap: break-word;text-align:left;font-family:Roboto;
                font-size:18px;font-weight:300;">
                {{ `${document.name}.${document.extension}` }}
              </p>
            </div>
            <div>
              <input type="button" value="Eliminar" class="deleteDocumentButton" :id="`delete_document_${document.abbreviation}_${index}`" style="float:right;"
                v-on:click="deleteDocument(document.abbreviation, document.name)">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListDocuments = false">
      </div>
    </Modal>
    <div>
      <ChooseReasonButton ref="chooseReasonButtonComponent" 
      valueButton1="Retiro Normal"
      valueButton2="Retiro por Defunción"
      v-on:choose-reason-request="getResponseSelectedReasonRequest($event)" 
      :showButtons="showFormAccess" />
    </div>
    <div v-if="this.reasonForTheRequest == 'defuncion'" style="margin-top:30px;">
      <Access ref="accessComponent" :tokenAuth="token_auth" :askNip="askNip" :showForm="showFormAccess"
        :showBackButton="true" backUrl="RetirementLanding"
        description="Ingresar los 13 caracteres del R.F.C. para solicitar tu renuncia." v-on:search-info-by-rfc-nip="getResponseAccess($event)"/>
    </div>
    <div v-if="this.reasonForTheRequest != 'defuncion'" style="margin-top:30px;">
      <Access ref="accessComponent" :tokenAuth="token_auth" :askNip="askNip" :showForm="showFormAccess"
        :showBackButton="true" backUrl="RetirementLanding"
        description="Ingresar los 13 caracteres del R.F.C. y tu NIP para solicitar tu renuncia." v-on:search-info-by-rfc-nip="getResponseAccess($event)"/>
    </div>
    <form @submit="register" v-if="rfcIsValid && hasAcceptedRequest == false">
      <div style="margin-top:30px;">
        <div>
          <PersonalInfo title="Datos Personales" :name="`${paternalName} ${maternalName} ${name}`" :rfc="rfcToShow" />
        </div>
        <div style="margin-top:30px;" class="container-controls">
          <div class="content-controls">
            <DateControl ref="dateComponent" description="Fecha de ingreso al FAS:"
              :day="day" :month="month" :year="year" :disableControls="hasPendingRequest"
              v-on:get-complete-date-selected="getResponseDate($event)" />
          </div>
        </div>
      </div>
      <div style="margin-top:30px;" v-if="typeRetirement == 'retiro_voluntario'">
        <p class="titleComponent" style="text-align:center;">Aportaciones al Retiro</p>
        <p class="totalSaved" style="margin-top:0px;">{{ amountWithoutInterest | currency }}</p>
      </div>
      <div style="margin-top:10px;" v-if="typeRetirement == 'retiro_voluntario'">
        <p class="titleComponent" style="text-align:center;">Interés Generado</p>
        <p class="totalSaved" style="margin-top:0px;">{{ interest | currency }}</p>
      </div>
      <div style="margin-top:10px;">
        <p class="titleComponent" style="text-align:center;">{{typeRetirementText}}</p>
        <p class="totalSaved" style="margin-top:0px;">{{ totalAmount | currency }}</p>
        <p style="font-family:Roboto;font-size:12px;margin-top:0px;">
          *Nota: Este monto puede variar después de la revisión por parte del Comité Técnico del FAS, 
          debido a adeudos y pagos atrasados.
        </p>
      </div>
      <div style="margin-top:30px;">
        <div class="mb-4">
          <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defuncion'" id="input_beneficiarie_name" type="text"
            v-model.trim="$v.beneficiarie_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_name.$error, 'inputsForm':!$v.beneficiarie_name.$invalid}"
              placeholder="Primer Nombre del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_name')">
          <div class="content-text">
            <div v-if="$v.beneficiarie_name.$error" class="text">
              <span class="errors" v-if="!$v.beneficiarie_name.required">El primer nombre es requerido</span>
              <span class="errors" v-if="!$v.beneficiarie_name.minLength">Debe ingresar más de 2 caracteres en el primer nombre</span>
              <span class="errors" v-if="!$v.beneficiarie_name.maxLength">Debe ingresar máximo 30 caracteres en el primer nombre</span>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defuncion'" id="input_beneficiarie_middle_name" type="text"
            v-model.trim="$v.beneficiarie_middle_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_middle_name.$error, 'inputsForm':!$v.beneficiarie_middle_name.$invalid}"
            placeholder="Segundo Nombre del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_middle_name')">
          <div class="content-text">
            <div v-if="$v.beneficiarie_middle_name.$error" class="text">
              <!--<span class="errors" v-if="!$v.beneficiarie_middle_name.required">El segundo nombre es requerido</span>-->
              <span class="errors" v-if="!$v.beneficiarie_middle_name.minLength">Debe ingresar más de 2 caracteres en el segundo nombre</span>
              <span class="errors" v-if="!$v.beneficiarie_middle_name.maxLength">Debe ingresar máximo 30 caracteres en el segundo nombre</span>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defuncion'" id="input_beneficiarie_paternal_name" type="text"
            v-model="$v.beneficiarie_paternal_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_paternal_name.$error, 'inputsForm':!$v.beneficiarie_paternal_name.$invalid}"
            placeholder="Apellido Paterno del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_paternal_name')">
          <div class="content-text">
            <div v-if="$v.beneficiarie_paternal_name.$error" class="text">
              <span class="errors" v-if="!$v.beneficiarie_paternal_name.required">Debe seleccionar por lo menos un apellido</span>
              <span class="errors" v-if="!$v.beneficiarie_paternal_name.minLength">Debe ingresar más de 2 caracteres en el apellido paterno</span>
              <span class="errors" v-if="!$v.beneficiarie_paternal_name.maxLength">Debe ingresar máximo 30 caracteres en el apellido paterno</span>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <input class="inputsForm capitalize" v-if="reasonForTheRequest == 'defuncion'" id="input_beneficiarie_maternal_name" type="text" 
            v-model="$v.beneficiarie_maternal_name.$model" :class="{'inputs-invalid-form':$v.beneficiarie_maternal_name.$error, 'inputsForm':!$v.beneficiarie_maternal_name.$invalid}"
            placeholder="Apellido Materno del Beneficiario" @keyup="validateSpecialCharacters('beneficiarie_maternal_name')">
          <div class="content-text">
            <div v-if="$v.beneficiarie_maternal_name.$error" class="text">
              <span class="errors" v-if="!$v.beneficiarie_maternal_name.required">Debe seleccionar por lo menos un apellido</span>
              <span class="errors" v-if="!$v.beneficiarie_maternal_name.minLength">Debe ingresar más de 2 caracteres en el apellido materno</span>
              <span class="errors" v-if="!$v.beneficiarie_maternal_name.maxLength">Debe ingresar máximo 30 caracteres en el apellido materno</span>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <div class="form-group">
            <input class="inputsForm" id="input_email" type="email" 
              v-model.trim="$v.email.$model" :disabled="hasPendingRequest"
              :class="{'inputs-invalid-form':$v.email.$error, 'inputsForm':!$v.email.$invalid}" placeholder="Correo Electrónico">
            <div class="content-text">
              <div v-if="$v.email.$error" class="text">
                <span class="errors" v-if="!$v.email.required">El correo electrónico es requerido</span>
                <span class="errors" v-if="!$v.email.isUnique">El formato del correo electrónico no es correcto. (su-correo@ejemplo.com)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4" style="">
          <input class="inputsForm" id="input_cellphone"  type="text" 
            placeholder="Celular" :disabled="hasPendingRequest"
            minlength="12" maxlength="12"  min="0" v-mask="'### ###-####'" v-model.trim="$v.cellphone.$model" 
            :class="{'inputs-invalid-form':$v.cellphone.$error, 'inputsForm':!$v.cellphone.$invalid}">
          <div class="content-text">
            <div v-if="$v.cellphone.$error" class="text">
              <span class="errors" v-if="!$v.cellphone.required">El celular es requerido</span>
              <span class="errors" v-if="!$v.cellphone.minLength">Debe ingresar los 10 dígitos del celular</span>
              <span class="errors" v-if="!$v.cellphone.maxLength">Debe ingresar los 10 dígitos del celular</span>
            </div>
          </div>
        </div>
        <div class="mb-4" style="">
          <input class="inputsForm" id="input_interbank_clabe" type="text" 
            v-model.trim="$v.interbankClabe.$model" :disabled="hasPendingRequest" placeholder="Clabe Interbancaria"
            :class="{'inputs-invalid-form':$v.interbankClabe.$error, 'inputsForm':!$v.interbankClabe.$invalid}" v-mask="'##################'">
          <div class="content-text">
            <div v-if="$v.interbankClabe.$error" class="text">
              <span class="errors" v-if="!$v.interbankClabe.required">La clabe interbancaria es requerida</span>
              <span class="errors" v-if="!$v.interbankClabe.minLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
              <span class="errors" v-if="!$v.interbankClabe.maxLength">Debe ingresar los 18 dígitos de la clabe interbancaria</span>
            </div>
          </div>
        </div>
        <div class="mb-4" style="">
          <select class="inputsForm" id="select_bank" 
            v-model.trim="$v.bank.$model" :disabled="hasPendingRequest"
            :class="{'inputs-invalid-form':$v.bank.$error, 'inputsForm':!$v.bank.$invalid}">
            <option value="Banco" selected hidden>Banco</option>
            <option v-for="bank in list_banks" :key="bank.id" :value="bank.name">{{bank.name}}</option>
          </select>
          <div class="content-text">
            <div v-if="$v.bank.$error" class="text">
              <span class="errors" v-if="!$v.bank.isUnique">El banco es requerido</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top:30px;" v-if="!hasPendingRequest">
        <div>
          <p class="titleComponent">Cargar Documentos</p>
        </div>
        <div class="contentLoadDocumentTable">
          <table class="table loadDocumentTable">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Estatus</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in documentsRequired" :key="item.id">
                <td>{{changeNameDocument(item.name)}}</td>
                <td>
                  <Check v-show="documentValidations.filter(a => a.abbreviation == item.abbreviation)[0].documentAttached" />
                </td>
                <td style="width:40%;">
                  <input v-if="!documentValidations.filter(a => a.abbreviation == item.abbreviation)[0].documentAttached && item.max_documents_required == 1"
                    type="button" value="Cargar" :id="`button_load_document_${item.abbreviation}`" class="loadDocumentButton" v-on:click="getFile(`input_file_upload_${item.abbreviation}`)">
                  <input v-if="item.max_documents_required > 1"
                    type="button" value="Cargar" :id="`button_load_document_${item.abbreviation}`" class="loadDocumentButton" v-on:click="getFile(`input_file_upload_${item.abbreviation}`)">
                  <input v-show="documentValidations.filter(a => a.abbreviation == item.abbreviation)[0].documentAttached" 
                    type="button" value="Detalle de Documentos" :id="`button_detail_${item.abbreviation}`" class="loadDocumentButtonWithoutBackground"
                    v-on:click="filterDocumentList(item.abbreviation, item.name)" style="margin-top:5px;" />
                  <div style='height: 0px;width:0px; overflow:hidden;'><input :id="`input_file_upload_${item.abbreviation}`" type="file" accept=".pdf,.png,.PNG,.jpeg" value="upload" @change="loadDocument($event, item.abbreviation, item.name)"/></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div style="margin-top:30px">
        <div v-show="hasPendingRequest">
          <input type="button" value="Cancelar Solicitud" v-on:click="cancelRequest()" class="AccessButton" id="button_cancel" />
        </div>
        <div v-show="!hasPendingRequest">
          <button class="AccessButton" id="button_save">Solicitar</button>
        </div>
        <div style="margin-top:10px">
          <div>
            <input type="button" value="Atrás" v-on:click="goBack()" class="AccessButtonWithoutBackground" id="backButton" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Check from '@/components/Loading/Check.vue'
import Loading from '@/components/Loading/Loading.vue'
import Modal from '@/components/Modal/Modal.vue'
import ChooseReasonButton from '@/components/ChooseReasonButton/ChooseReasonButton'
import Access from '@/components/Forms/Access.vue'
import DateControl from '@/components/Forms/Date.vue'
import PersonalInfo from '@/components/PersonalInfo/PersonalInfo.vue'

import User from '@/classes/User'
import Document from '@/classes/Document'
import Retirement from '@/classes/Retirement'

import {validateEmail} from '@/helpers/email'
import {getYearsElapsedBetweenTwoDates} from '@/helpers/dates'
import {largeMonths} from '@/helpers/enums'
import {required, minLength, maxLength, email, requiredIf} from 'vuelidate/lib/validators'
import { getBanks } from "@/api/bank";

const methodsForCalculateSavingsRetirement = {
  "defuncion": "getTotalRetirementByDeath",
  "normal": "getTotalRetirement",
}

export default {
  data() {
    return {
      rfcIsValid: false,
      token_auth: "",
      askNip: true,
      showForm: true,
      paternalName: "",
      maternalName: "",
      name: "",
      rfc: "",
      rfcToShow: "",
      isLoading: false,
      totalAmount: 0,
      amountWithoutInterest: 0,
      interest: 0,
      percentage: "",
      typeRetirement: "",
      typeRetirementText: "Total de Retiro",
      admissionDate: "",
      email: "",
      cellphone: "",
      interbankClabe: "",
      bank: "Banco",
      userObjectClass: null,
      documentObjectClass: null,
      retirementObjectClass: null,
      showFormAccess: true,
      list_banks: [],
      documents_list: [],
      documents_list_filtered: [],
      showModalListDocuments: false,
      hasPendingRequest: false,
      hasAcceptedRequest: null,
      day: 'Día',
      month: 'Mes',
      year: 'Año',
      requestId: 0,
      reasonForTheRequest: "",
      beneficiarie_name: "",
      beneficiarie_middle_name: "",
      beneficiarie_paternal_name: "",
      beneficiarie_maternal_name: "",
      documentsRequired: [],
      documentValidations: [],
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  validations: {
    beneficiarie_name: {
      required: requiredIf(function() {
        if (this.reasonForTheRequest == 'defuncion')
          return true;
        return false;
      }),
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    beneficiarie_middle_name: {
      minLength: minLength(3),
      maxLength: maxLength(30)
    },
    beneficiarie_paternal_name: {
      minLength: minLength(3),
      maxLength: maxLength(30),
      required: requiredIf(function() {
        if (this.reasonForTheRequest == 'defuncion' && this.beneficiarie_maternal_name == "")
          return true;
        return false;
      }),
    },
    beneficiarie_maternal_name: {
      minLength: minLength(3),
      maxLength: maxLength(30),
      required: requiredIf(function() {
        if (this.reasonForTheRequest == 'defuncion' && this.beneficiarie_paternal_name == "")
          return true;
        return false;
      }),
    },
    email: {
      required,
      email,
      isUnique(value) {
        return validateEmail(value);
      }
    },
    cellphone: {
      required,
      minLength: minLength(12),
      maxLength: maxLength(12)
    },
    interbankClabe: {
      required,
      minLength: minLength(18),
      maxLength: maxLength(18)
    },
    bank: {
      required,
      isUnique(value) {
        if (value == "Banco") {
          return false;
        }

        return true;
      }
    }
  },
  name: 'RetirementRequestComponent',
  components: {
    Check,
    Loading,
    Modal,
    ChooseReasonButton,
    Access,
    DateControl,
    PersonalInfo
  },
  beforeMount() {
    this.userObjectClass = new User();
    this.documentObjectClass = new Document();
    this.retirementObjectClass = new Retirement();
    this.login();
  },
  mounted() {
    
  },
  methods: {
    register(e) {
      e.preventDefault();
      this.$v.$touch();
      this.$refs.dateComponent.$v.$touch()

      if (!this.$v.$invalid && !this.$refs.dateComponent.$v.$invalid) {
        this.isLoading = true;

        let documentsComplete = this.areDocumentsComplete();
        if (!documentsComplete) {
          this.isLoading = false;
          return;
        }

        let json = this.createObjectToCreateRetirementRequest();
        this.retirementObjectClass.save(json).then(response => {
          this.isLoading = false;
          this.cleanValueChecks();
          this.cleanAllControls();
          this.$refs.accessComponent.cleanFields();
          this.$refs.dateComponent.cleanFields()
          this.$refs.chooseReasonButtonComponent.clean();
          Swal.fire({
            text: "Solicitud de Carta de no Adeudo guardada correctamente",
            html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Retiro guardada correctamente</p><br/>
                  <p style="font-size:14px;">Todas las solicitudes capturadas a través de esta página, 
                  serán analizadas y sujetas a aprobación por parte del Comité Técnico de la Sección 17.</p>`,
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
            icon: "success",
          }).then((response)=>{
            //this.$router.push({ name: 'HomeLoanRequest' });
          });
        }).catch(error => {
          this.isLoading = false;
          Swal.fire({
            title: "Aviso",
            text: error,
            icon: "error",
          });
        });
      }
    },
    createObjectToCreateRetirementRequest() {
      let json = {
        token_auth: this.token_auth,
        rfc: this.rfcToShow,
        email: this.email,
        cellphone: this.removeMask(this.cellphone),
        date_of_admission: this.admissionDate,
        interbank_clabe: this.interbankClabe,
        bank_name: this.bank,
        amount: this.totalAmount,
        amount_without_interest: this.amountWithoutInterest,
        interest: this.interest,
        percentage: this.percentage,
        type_of_retirement: this.typeRetirement,
        beneficiary_name: this.beneficiarie_name,
        beneficiary_middle_name: this.beneficiarie_middle_name,
        beneficiary_maternal_name: this.beneficiarie_maternal_name,
        beneficiary_paternal_name: this.beneficiarie_paternal_name,
        document_list: this.documents_list
      }

      return json;
    },
    cancelRequest() {
      Swal.fire({
        title: "Aviso",
        text: '¿Desea cancelar su Solicitud de Retiro?',
        icon: "warning",
        customClass: {
          container: 'my-swal'
        },
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.retirementObjectClass.cancel(this.token_auth, this.requestId).then(response => {
            this.isLoading = false;
            this.cleanValueChecks();
            this.cleanAllControls();
            this.$refs.accessComponent.cleanFields();
            this.$refs.dateComponent.cleanFields()
            this.$refs.chooseReasonButtonComponent.clean();
            Swal.fire({
              html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Retiro cancelada correctamente</p>`,
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
              icon: "success",
            }).then((response)=>{
            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            });
          });
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    getRetirementRequestAccepted() {
      this.isLoading = true;
      return this.retirementObjectClass.getByRfc(this.token_auth, this.rfcToShow).then(response => {
        this.isLoading = false;
        if (response.data.response.retirement_request != null) {
          let acceptedRequest = response.data.response.retirement_request.filter(b => b.status === "aceptado");
          this.hasAcceptedRequest = acceptedRequest.length > 0 ? true : false;

          if (this.hasAcceptedRequest) {
            Swal.fire({
              text: "Solicitud de retiro guardada correctamente",
              html: `<p style="font-size:14px;font-family:Roboto;">Usted ya cuenta con una Solicitud de Retiro aceptada.</p>`,
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
              icon: "info",
            });
          }
        } else {
          this.hasAcceptedRequest = false;
        }
      }).catch(error => {
        this.isLoading = false;
        this.hasAcceptedRequest = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getRetirementRequest() {
      this.isLoading = true;
      this.retirementObjectClass.getByRfc(this.token_auth, this.rfcToShow).then(response => {
        this.isLoading = false;
        if (response.data.response.retirement_request != null) {
          let pendingRequest = response.data.response.retirement_request.filter(b => b.status === "pendiente");
          this.hasPendingRequest = pendingRequest.length > 0 ? true : false;
          if (this.hasPendingRequest) {
            this.setRetirementRequested(pendingRequest[0]);
          }
        }
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    setRetirementRequested(json) {
      this.requestId = json.id;
      this.email = json.email;
      this.cellphone = json.cellphone;
      this.interbankClabe = json.interbank_clabe;
      this.interbankClabe = json.interbank_clabe;
      this.bank = json.bank_name;
      let admissionDate = json.date_of_admission.split('-');
      this.day = admissionDate[2]
      this.month = largeMonths[admissionDate[1]]
      this.year = admissionDate[0]
      this.$refs.dateComponent.setDate(this.day, this.month, this.year)
      
      this.typeRetirementText = `Total De Retiro (${Retirement.typeRetirement[json.type_of_retirement]})`
      this.$emit('get-type-retirement', `Solicitud de Retiro (${Retirement.typeRetirement[json.type_of_retirement]})`);

      this.amountWithoutInterest = json.amount_without_interest;
      this.totalAmount = json.amount;
      this.interest = json.interest == null ? 0 : json.interest;
      this.percentage = json.percentage;
      this.typeRetirement = json.type_of_retirement;
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getBanks() {
      getBanks(this.token_auth).then(response => {
        this.list_banks = response.data.response.lista_bancos;
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    getResponseAccess(event) {
      if (event.rfcIsValid) {
        this.setAuthenticatedUserInformation(event.data);
        this.getDocumentsRequired();
        this.getRetirementRequestAccepted().then(response => {
          if (!this.hasAcceptedRequest) {
            this.showFormAccess = false;
            this.getRetirementRequest(); 
          }
        })
        this.getBanks();
      }
      this.rfcIsValid = event.rfcIsValid;
    },
    getResponseDate(event) {
      if (event != "") {
        if (!this.hasPendingRequest) {
          this.admissionDate = event;
          this.getTotalRetirement();  
        }
      } else {
        this.admissionDate = event;
        this.totalAmount = 0;
        this.interest = 0;
        this.percentage = "";
        this.typeRetirement = "";
      }
    },
    getResponseSelectedReasonRequest(event) {
      this.reasonForTheRequest = event.selectedReason;
      this.askNip = event.askAccessNip;
    },
    async getDocumentsRequired() {
      try {
        let requiredIn = this.reasonForTheRequest == "defuncion" ? "Renuncia al retiro por defunción" : "Renuncia al retiro normal"
        let response = await this.documentObjectClass.getDocumentsRequired(this.token_auth, requiredIn);
        this.documentsRequired = response.data.response.data;
        this.createDocumentValidationsObject(this.documentsRequired);
      } catch (error) {
        Swal.fire({
          title: "Aviso",
          text: "Error al consultar documentos requeridos",
          icon: "error",
        });
      }
    },
    createDocumentValidationsObject(documentsRequired) {
      this.documentValidations = [];
      documentsRequired.forEach(element => {
        this.documentValidations.push({
          abbreviation: element.abbreviation,
          documentAttached: false
        })
      });
    },
    setAuthenticatedUserInformation(userAuthenticated) {
      this.name = userAuthenticated.name;
      this.paternalName = userAuthenticated.paternal_name;
      this.maternalName = userAuthenticated.maternal_name;
      this.rfcToShow = userAuthenticated.rfc;
    },
    getFile(selector) {
      this.documentObjectClass.getFileByIdSelector(selector);
    },
    loadDocument(event, type, typeDescription) {
      let file = event.target.files;
      let filename = file[0].name;
      let extension = file[0].type.split('/')[1];

      if(this.documents_list.length > 0){
        if (!this.documentTypeReachItsLimit(type)) {
          if (this.existDocument(this.documents_list, filename.split('.')[0].replace(/\s/g, '_'))) {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: "El archivo seleccionado ya ha sido cargado",
              icon: "error",
            });
            return;
          }
        } else {
          Swal.fire({
            title: "Aviso",
            text: `Solo puede subir 5 documentos en el apartado de ${typeDescription}`,
            icon: "error",
          });
          return;
        }
      }

      this.documentObjectClass.serialize(file[0]).then(base64Response => {
        this.setDocumentList(base64Response, filename.split('.')[0].replace(/\s/g, '_'), extension, type);
        this.changeValueChecks(true, type);
        this.showLoadedDocumentSuccessMessage(filename, typeDescription);
      }).catch(error => {
        console.error(error);
      });
    },
    setDocumentList(fileBase64, fileName, extension, abbreviation) {
      this.documents_list.push({
        file: fileBase64,
        name: fileName,
        extension: extension,
        abbreviation: abbreviation
      });
    },
    changeValueChecks(value, document) {
      let index = -1;
      if (!value) {
        index = this.documents_list.findIndex(b => b.abbreviation === document);
        value = index != -1 ? true : value
      }

      let indexDocumentValidations = this.documentValidations.findIndex(b => b.abbreviation === document);

      if (indexDocumentValidations != -1) {
        this.documentValidations[indexDocumentValidations].documentAttached = value
      }
    },
    showLoadedDocumentSuccessMessage(documentName, documentType) {
      Swal.fire({
        text: "Solicitud de retiro guardada correctamente",
        html: `<p style="font-size:14px;font-family:Roboto;">El documento: <span style="font-weight:500;">${documentName}</span> se ha adjuntado en el apartado de ${documentType}.</p>`,
        confirmButtonText: "Continuar",
        allowOutsideClick: false,
        icon: "success",
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm', '');
    },
    filterDocumentList(document, modalTitle) {
      this.documents_list_filtered = this.documents_list.filter(b => b.abbreviation === document);
      this.modalTitle = modalTitle;
      this.showModalListDocuments = true;
    },
    deleteDocument(document, documentName){
      Swal.fire({
        title: "Aviso",
        text: '¿Desea eliminar el documento?',
        icon: "warning",
        customClass: {
          container: 'my-swal'
        },
        showCancelButton: true,
        confirmButtonColor: '#12B3BD',
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then((result) => {
        if (result.value) {
          let indexDocuments = this.documents_list.findIndex(d => d.abbreviation === document && d.name === documentName);
          let indexDocumentsFiltered = this.documents_list_filtered.findIndex(d => d.abbreviation === document && d.name === documentName);
          if (indexDocuments != -1) {
            this.documents_list.splice(indexDocuments,1);
            this.changeValueChecks(false, document);
          } 
          if (indexDocumentsFiltered != -1) {
            this.documents_list_filtered.splice(indexDocumentsFiltered,1);
          } 
        }
      });
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_delete', 'button_cancel_delete');
    },
    documentTypeReachItsLimit(document) {
      let documents = this.documents_list.filter(d => d.abbreviation === document);
      if (documents.length >= 5) {
        return true;
      }
      return false;
    },
    existDocument(documents, newDocument) {
      let indexDocuments = documents.findIndex(d => d.name === newDocument);
      if (indexDocuments != -1) {
        return true;
      }
      return false;
    },
    validateSpecialCharacters(field) {
      var regex = /^[a-zA-ZÀ-ÿ]+$/;
      if (regex.test(this[field]) != true) {
        this[field] = this[field].replace(/[^a-zA-ZÀ-ÿ@\s]+/, '');
      }
    },
    areDocumentsComplete() {
      if (this.documentValidations.length > 0) {
        let documentValidationsFiltered = this.documentValidations.filter(a => !a.documentAttached);

        if (documentValidationsFiltered.length > 0) {
          Swal.fire({
            title: "Aviso",
            text: "Favor de completar la carga de documentos.",
            icon: "warning",
          })
          return false;
        }  
      } else {
        return false;  
      }
      

      return true;
    },
    cleanValueChecks() {
      this.documentValidations = [];
    },
    cleanAllControls() {
      this.requestId = 0;
      this.hasPendingRequest = false;
      this.hasAcceptedRequest = null;
      this.rfcToShow = "";
      this.rfcIsValid = false;
      this.showFormAccess = true;
      this.email = "";
      this.cellphone = "";
      this.interbankClabe = "";
      this.bank = "Banco";
      this.documents_list = [];
      this.documents_list_filtered = [];
      this.day = "Día";
      this.month = "Mes";
      this.year = "Año";
      this.totalAmount = 0;
      this.interest = 0;
      this.amountWithoutInterest = 0;
      this.typeRetirement = "";
      this.beneficiarie_name = "";
      this.beneficiarie_middle_name = "";
      this.beneficiarie_paternal_name = "";
      this.beneficiarie_maternal_name = "";
      this.typeRetirementText = `Total De Retiro`
      this.$emit('get-type-retirement', `Solicitud de Retiro`);
      this.$v.$reset()
    },
    goBack() {
      this.cleanValueChecks();
      this.cleanAllControls();
      this.$refs.accessComponent.cleanFields();
      this.$refs.dateComponent.cleanFields();
      this.$refs.chooseReasonButtonComponent.clean();
    },
    getTotalRetirement() {
      this.isLoading = true;
      this.retirementObjectClass[methodsForCalculateSavingsRetirement[this.reasonForTheRequest]](this.token_auth, this.rfcToShow, this.admissionDate).then(response => {
        this.isLoading = false;
        this.totalAmount = response.data.response.retirement_request.amount;
        this.amountWithoutInterest = response.data.response.retirement_request.amount_without_interest;
        this.interest = response.data.response.retirement_request.interest == null ? 0 : response.data.response.retirement_request.interest;
        this.percentage = response.data.response.retirement_request.percentage;
        if (this.reasonForTheRequest == "defuncion") {
          this.typeRetirement = "defuncion";
          this.typeRetirementText = `Total De Retiro (${Retirement.typeRetirement['defuncion']})`
          this.$emit('get-type-retirement', `Solicitud de Retiro (${Retirement.typeRetirement['defuncion']})`);
        } else {
          this.typeRetirement = response.data.response.retirement_request.type_of_retirement;
          this.typeRetirementText = `Total De Retiro (${Retirement.typeRetirement[response.data.response.retirement_request.type_of_retirement]})`
          this.$emit('get-type-retirement', `Solicitud de Retiro (${Retirement.typeRetirement[response.data.response.retirement_request.type_of_retirement]})`);
        }
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    removeMask(phone) {
      if (phone.includes("(")) {
        phone = phone.replace("(", "");
      }
      if (phone.includes(")")) {
        phone = phone.replace(")", "");
      }
      if (phone.includes("-")) {
        phone = phone.replace("-", "");
      }
      if (phone.includes(" ")) {
        phone = phone.replace(" ", "");
      }
      return phone;
    },
    setIdAttributeToAccepAndCancelButtonSwalFire(idButtonConfirm="", idButtonCancel="") {
      if (idButtonConfirm != "") {
        $('.swal2-confirm').attr('id', idButtonConfirm);  
      }
      
      if (idButtonCancel != "") {
        $('.swal2-cancel').attr('id', idButtonCancel); 
      }
    },
    changeNameDocument(abbreviation){
      switch (abbreviation) {
        case "Identificación del Socio":
          if (this.reasonForTheRequest == 'defuncion'){
            return "INE/IFE del Socio"
          }else{
            return "INE/IFE"
          }
        case "Identificación oficial del Beneficiario":
          if (this.reasonForTheRequest == 'defuncion'){
            return "INE/IFE del Beneficiario"
          }else{
            return "INE/IFE"
          }
        case "Ultimo comprobante de pago del Socio":
          return "Talones de Pago del Socio"
        default:
          return abbreviation
      }
    }
  }
}
</script>